{
  "behaviorSummaryCard": {
    "ronLikelihood": {
      "label": "Probabilité de RON",
      "tooltip": "Probabilité que cet aéronef reste pour la nuit"
    },
    "typicalArrival": {
      "label": "Arrivée type",
      "tooltip": "Heure d'arrivée la plus fréquente pour cet aéronef"
    },
    "typicalTurn": {
      "label": "Escale type",
      "tooltip": "Temps moyen au sol entre arrivée et départ",
      "tooltipDetail": "Basé sur les données de vol historiques"
    },
    "visitTypes": {
      "quickTurn": "Escale rapide",
      "dayStop": "Escale jour",
      "ron": "RON"
    },
    "basedOn": "Basé sur",
    "title": "Résumé du comportement"
  },
  "filters": {
    "flightTypes": {
      "all": "Tout",
      "arrivals": "Arrivées",
      "departures": "Départs"
    },
    "statuses": {
      "scheduled": "Planifié",
      "active": "Actif",
      "landed": "Atterri",
      "cancelled": "Annulé"
    },
    "flags": {
      "vipOnly": "VIP seul",
      "favoritesOnly": "Favoris uniquement",
      "showIgnored": "Voir ignorés"
    },
    "search": {
      "placeholder": "Rechercher des vols..."
    },
    "lastUpdated": {
      "neverUpdated": "Jamais mis à jour",
      "justNow": "À l'instant",
      "minutesAgo": "Il y a min",
      "secondsAgo": "À l'instant"
    },
    "dropdowns": {
      "allStatus": "Tout statut",
      "flags": "Signaux",
      "operator": "Opérateur"
    },
    "myReservations": "Mes réservations",
    "liveStatus": "LIVE",
    "arrivingSoon": "Arrivée imminente"
  },
  "services": {
    "fuel": "Fuel",
    "hangar": "Hangar",
    "catering": "Restauration",
    "hotel": "Hôtel",
    "crewCar": "Véhicule équipage",
    "limo": "Limo",
    "carRental": "Location auto",
    "arrivalLimo": "Limo arrivée",
    "departureLimo": "Limousine départ",
    "deicing": "Dégivrage",
    "groundPower": "Alim. au sol",
    "gpu": "GPU",
    "lavatory": "Toilettes",
    "lavService": "Serv. toilettes",
    "water": "Eau",
    "towing": "Tractage",
    "oxygen": "Oxygène",
    "conferenceRoom": "Salle de conférence",
    "customs": "Douane",
    "cipService": "Service CIP",
    "payment": "Paiement",
    "dishes": "Vaisselle",
    "linens": "Linges",
    "otherArrival": "Autre (Arrivée)",
    "otherDeparture": "Autre (Départ)"
  },
  "flightRow": {
    "tooltips": {
      "hasReservation": "A une réservation"
    }
  },
  "flightNotes": {
    "defaultTags": {
      "ops": "Ops",
      "fuel": "Fuel",
      "catering": "Restauration",
      "hotel": "Hôtel",
      "crew": "Équip.",
      "vipRequest": "Demande VIP",
      "followUp": "Suivi",
      "urgent": "Urgent"
    },
    "search": {
      "placeholder": "Rechercher notes...",
      "clearSearch": "Effacer",
      "noMatches": "Aucun résultat"
    },
    "emptyState": {
      "title": "Aucune note",
      "message": "Utilisez les notes pour coordonner avec votre équipe concernant ce vol",
      "quickActions": {
        "passengersArrived": {
          "label": "Passagers arrivés",
          "template": "Passagers arrivés",
          "tag": "Ops"
        },
        "fuelCompleted": {
          "label": "Avitaillement terminé",
          "template": "Service carburant terminé",
          "tag": "Fuel"
        },
        "crewCalled": {
          "label": "Équipage appelé",
          "template": "L'équipage a été notifié",
          "tag": "Équip."
        },
        "ownerRequest": {
          "label": "Demande proprio",
          "template": "Demande du proprio :",
          "tag": "Demande VIP"
        }
      }
    },
    "dateLabels": {
      "today": "Auj.",
      "yesterday": "Hier"
    },
    "composer": {
      "placeholder": "Ajouter une note...",
      "quickTags": "Tags rapides",
      "helpText": "Appuyez sur Entrée pour envoyer, Maj+Entrée pour un saut de ligne"
    },
    "noteActions": {
      "edited": "modifié",
      "cancel": "Annuler"
    },
    "messages": {
      "loadFailed": "Échec du chargement des notes",
      "notePinned": "Note épinglée",
      "noteUnpinned": "Note désépinglée",
      "updateFailed": "Modification de la note échouée",
      "noteUpdated": "Note mise à jour",
      "noteDeleted": "Note supprimée",
      "deleteFailed": "Suppression de la note échouée",
      "noteCopied": "Note copiée dans le presse-papiers",
      "copyFailed": "Échec de la copie de la note"
    },
    "confirmations": {
      "deleteNote": "Supprimer cette note ? Cette action est irréversible."
    }
  },
  "flightList": {
    "emptyState": {
      "noFlightsFound": "Aucun vol trouvé",
      "tryAdjustingFilters": "Essayez d'ajuster vos filtres"
    }
  },
  "notesDialog": {
    "labels": {
      "vip": "VIP"
    }
  },
  "opsCenterLoading": {
    "logoAlt": "Logo AirPlx",
    "messages": {
      "fetchingOperations": "Chargement des opérations...",
      "syncingFlightAware": "Synchronisation avec FlightAware...",
      "loadingPositions": "Chargement des positions...",
      "updatingArrivals": "Mise à jour des arrivées...",
      "checkingDepartures": "Vérification des départs...",
      "pullingTracking": "Récupération des données de suivi..."
    }
  },
  "tailDetailDrawer": {
    "overallTendencies": {
      "title": "Tendances générales",
      "lastDays": "Derniers j.",
      "subtitle": "Sous-titre"
    },
    "estimatedFuel": {
      "label": "Carburant estimé",
      "tooltip": "Besoins en carburant estimés selon le type d'appareil et la distance de vol habituelle",
      "low": "Bas",
      "high": "Élevé"
    },
    "flightsPerDay": {
      "label": "Vols/Jour",
      "tooltip": "Activité de vol moyenne pour cet aéronef",
      "tooltipDetail": "Par rapport aux types d'aéronefs similaires",
      "busier": "Plus actif",
      "quieter": "Plus calme"
    },
    "medianStay": {
      "label": "Durée médiane",
      "tooltip": "Durée habituelle de stationnement de cet appareil à votre FBO",
      "tooltipDetail": "Basé sur les visites précédentes",
      "shorter": "Plus court",
      "longer": "Plus long"
    },
    "ronPercentage": {
      "label": "RON %",
      "tooltip": "Pourcentage de visites incluant une nuitée",
      "tooltipDetail": "Pourcentage de nuitées",
      "quick": "Rotations rapides",
      "overnight": "Nuit"
    },
    "recentFlights": {
      "noFlights": "Aucun vol récent",
      "tableHeaders": {
        "date": "Date",
        "route": "Route",
        "times": "Heures",
        "stay": "Rester",
        "duration": "Durée",
        "status": "Statut"
      },
      "lastDays": "Derniers j.",
      "title": "Vols récents"
    },
    "prediction": {
      "atAirport": "À l'aéroport",
      "basedOn": "Basé sur",
      "confidence": "Confiance"
    }
  },
  "tvFooter": {
    "justNow": "À l'instant",
    "never": "Jamais",
    "hoursAgo": "Il y a %h h",
    "minutesAgo": "Il y a min",
    "secondsAgo": "À l'instant",
    "updated": "Mis à jour"
  },
  "tvHeader": {
    "live": "DIRECT",
    "autoScroll": "Défil. auto",
    "exitTVMode": "Quitter le mode TV",
    "switchToDarkMode": "Passer en mode sombre",
    "switchToLightMode": "Passer en mode clair",
    "lastUpdated": "Mis à jour le"
  },
  "tvModeButton": {
    "tooltip": "Ouvrir en mode TV",
    "dialogTitle": "Mode TV",
    "tvModeLink": "Lien mode TV",
    "helperText": "Ouvrez ce lien sur un écran pour afficher le tableau des vols",
    "activeFilters": "Filtres actifs",
    "noFilters": "Aucun filtre actif",
    "filterLabels": {
      "arrivals": "Arrivées uniquement",
      "departures": "Départs uniquement",
      "vipOnly": "VIP seul",
      "favoritesOnly": "Favoris uniquement",
      "myReservations": "Mes réservations",
      "showIgnored": "Inclure les ignorés",
      "search": "Recherche",
      "status": "Statut",
      "type": "Type"
    },
    "buttons": {
      "copyLink": "Copier lien",
      "copied": "Copié !",
      "openInNewWindow": "Nouvelle fenêtre",
      "cancel": "Annuler"
    }
  },
  "alertToast": {
    "relativeTime": {
      "hoursAgo": "Il y a %h h",
      "justNow": "À l'instant",
      "minutesAgo": "Il y a min",
      "oneHourAgo": "Il y a une heure",
      "oneMinuteAgo": "Il y a une minute"
    },
    "unknownAircraft": "Aéronef inconnu"
  },
  "dashboard": {
    "errors": {
      "failedToLoadFlights": "Erreur : Échec du chargement des vols"
    }
  },
  "dataCoverageIndicator": {
    "etaAvailable": "ETA disponible",
    "liveTracking": "Suivi en direct",
    "noETA": "Pas d'ETA",
    "noLiveData": "Pas de données",
    "operatorKnown": "Opérateur connu",
    "unknownOperator": "Opérateur inconnu"
  },
  "flightDetailDrawer": {
    "altitudeStates": {
      "climbing": "Montée",
      "descending": "Descente",
      "level": "Niveau"
    },
    "buttons": {
      "cancel": "Annuler",
      "save": "Enregistrer"
    },
    "fields": {
      "actualIn": "Arr. réelle :",
      "actualOut": "Départ réel :",
      "airport": "Aéroport :",
      "altitude": "Altitude :",
      "altitudeChange": "Changement d'altitude :",
      "assignedRampSpot": "Spot assigné :",
      "atcCallsign": "Indicatif ATC :",
      "code": "Code :",
      "delay": "Retard :",
      "estimatedIn": "Arrivée estimée :",
      "estimatedOut": "Départ estimé :",
      "flightId": "ID vol :",
      "fuelRequest": "Carburant :",
      "groundspeed": "Vitesse sol :",
      "hangarRequested": "Hangar demandé :",
      "heading": "Cap :",
      "iata": "Iata :",
      "lastUpdated": "Mis à jour :",
      "makeModel": "Marque Modèle :",
      "position": "Position :",
      "progress": "Progression :",
      "registration": "Immatriculation :",
      "scheduledIn": "Arrivée prévue :",
      "scheduledOut": "Départ prévu :",
      "status": "Statut :",
      "terminalGate": "Porte :",
      "type": "Type :"
    },
    "formats": {
      "delayMinutes": "Minutes de retard",
      "gate": "Porte",
      "terminal": "Terminal"
    },
    "noFlightSelected": "Aucun vol sélectionné",
    "placeholders": {
      "fuel": "Fuel",
      "spot": "Place"
    },
    "sections": {
      "aircraft": "Aéronef",
      "destination": "Destination",
      "flightInformation": "Informations de vol",
      "internalNotes": "Notes internes",
      "livePosition": "Position en direct",
      "operations": "Opérations",
      "operator": "Opérateur",
      "origin": "Origine"
    },
    "units": {
      "degrees": "Degrés",
      "feet": "Pieds",
      "knots": "Nœuds"
    }
  },
  "opsMap": {
    "airport": {
      "code": "Code",
      "name": "Nom"
    },
    "emptyState": "État vide",
    "labels": {
      "eta": "ETA",
      "etd": "ETD",
      "from": "De"
    }
  },
  "otherServicesPopover": {
    "title": "Autres services"
  }
}
